const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || '/api/contact';
const formRenderedAt = Date.now();

const buildClientMetadata = () => ({
  formRenderedAt,
  submittedAtClient: Date.now(),
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  userAgent: window.navigator.userAgent
});

const parseErrorMessage = async (response) => {
  try {
    const payload = await response.json();
    return payload?.message || 'We could not send this automatically right now.';
  } catch (error) {
    return 'We could not send this automatically right now.';
  }
};

/**
 * Send form data to the backend contact endpoint.
 * Email provider credentials stay on the backend and are never bundled into the browser app.
 *
 * @param {Object} formData - The form data to send
 * @returns {Promise<Object>} - Promise resolved after the backend accepts the request
 */
export const sendContactForm = async (formData) => {
  const response = await fetch(CONTACT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...formData,
      botField: formData.website || '',
      clientMetadata: buildClientMetadata()
    })
  });

  if (!response.ok) {
    throw new Error(await parseErrorMessage(response));
  }

  return response.json();
};
